import { styled } from "goober";
import { panelFrameStyles } from "./PanelFrame";

export const ExecutionPanel = styled("div")`
  position: relative;
  display: flex;
  flex: 1;
  min-width: 0;
  width: 100%;
  height: 100%;

  &[data-framed="true"] {
    ${panelFrameStyles}
  }
`;

export const ExecutionPanelContent = styled("div")`
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100%;
`;
